import { React } from 'react'
import MainSubMenu from 'app-menus/main-sub-menu'
import { useAppContext } from 'context'
import { useDeveloperProjects } from 'data/project'
import { CircularProgress } from '@mui/material'
import { toast } from 'sonner'
import { twMerge } from 'tailwind-merge'
import * as Dropdown from '@radix-ui/react-dropdown-menu'
import { Link } from 'react-router-dom'
import { BsThreeDotsVertical } from 'react-icons/bs'

export default function ClientDataForm() {
  const { developer } = useAppContext()

  const {
    data: projects,
    isLoading: isLoadingProjects,
    isError: isErrorFetchingProjects,
  } = useDeveloperProjects({ developer: developer.split(' ')?.[0] })

  if (isErrorFetchingProjects) {
    toast.error('Error fetching developer projects')
  }

  return (
    <div className="relative w-[80%] bg-06 bg-opacity-80 shadow-[30px_30px_4px_0px_rgba(0,0,0,0.15)]  min-h-[65vh] max-h-[76vh]  overflow-y-hidden overflow-x-hidden rounded-[40px] px-16 py-8 justify-center justify-items-center">
      <div className="w-full justify-center relative  flex ">
        <div className="capitalHeading">
          <span className="bg-gradient-to-b font-libre from-[#9f9c5d] to-[rgba(193,155,22,1)] text-4xl text-transparent bg-clip-text  ">
            {developer.split(' ')?.[0]}
          </span>
          <span className="text-09 text-opacity-80 font-libre  text-4xl">
            {' '}
            {developer.split(' ')?.[1]}
          </span>
        </div>
        <div className="absolute top-0 right-10">
          <MainSubMenu />
        </div>
      </div>
      {isLoadingProjects ? (
        <div className=" grid place-items-center mt-36">
          <CircularProgress color="inherit" className="text-02" size={30} />
        </div>
      ) : (
        projects &&
        (projects.length ? (
          <div className="  max-h-[48vh] pt-4 overflow-y-auto ml-10 flex justify-center  ">
            <table className=" w-[70%] min-w-[65%]  max-w-[80%] ">
              <thead className="font-libre font-semibold text-02">
                <tr className=" graph-title  ">
                  <th className=" w-[200px] pl-6 py-5 text-left font-semibold font-libre   tracking-wider text-02">
                    Project Name
                  </th>
                  <th className=" w-[100px] pl-4 text-left font-semibold font-libre   tracking-wider text-02">
                    City
                  </th>
                  <th className=" w-[150px] text-left  font-semibold font-libre   tracking-wider text-02">
                    Province
                  </th>
                  <th className=" w-[80px]  text-left  text-transparent font-semibold font-libre   tracking-wider text-02"></th>
                </tr>
              </thead>
              <tbody>
                {projects.map((item) => (
                  <tr className="odd:bg-[#c9cd77] align-middle ">
                    <td className=" text-sm py-2 pl-6 font-libre tracking-wider text-02 rounded-l-lg ">
                      {item.project_name}
                    </td>
                    <td className=" text-sm font-libre tracking-wider text-02">{item.city}</td>
                    <td className="  text-sm font-libre tracking-wider  text-02">
                      {item.province}
                    </td>
                    <td className=" text-sm font-libre tracking-wider text-02 rounded-r-lg">
                      <Dropdown.Root>
                        <Dropdown.Trigger className="focus:outline-none">
                          <button>
                            <BsThreeDotsVertical size={25} />
                          </button>
                        </Dropdown.Trigger>
                        <Dropdown.Portal>
                          <Dropdown.Content
                            className={twMerge(
                              'z-[100] data-[side=left]:animate-slideRightAndFade data-[side=right]:animate-slideLeftAndFade data-[side=top]:animate-slideDownAndFade',
                              'min-w-fit rounded-xl border border-bca-grey-2 bg-[#c9cd77] px-8 py-4 shadow-[0px_7px_7px_-2px_#10182808]',
                              ' font-libre will-change-[opacity,transform] data-[side=bottom]:animate-slideUpAndFade'
                            )}
                            align="end"
                          >
                            <Dropdown.Group>
                              <ul className=" m-auto text-sm text-center  text-[#42644c] divide-y-[2px] divide-02 font-libre block justify-center">
                                <li>
                                  <Link
                                    to={`/project-data-form/${item.id}`}
                                    className="block lg:inline-block px-4 py-3 "
                                  >
                                    Edit Project Data
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to={`/capital-sources?project=${item.project_name.replace(/\s+/g, '-')}`}
                                    className="block lg:inline-block px-4 py-3 "
                                  >
                                    Capital Sources
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to={`/account?project=${item.project_name.replace(/\s+/g, '-')}`}
                                    className="block lg:inline-block px-4 py-3 "
                                  >
                                    Project Account
                                  </Link>
                                </li>
                              </ul>
                            </Dropdown.Group>
                          </Dropdown.Content>
                        </Dropdown.Portal>
                      </Dropdown.Root>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className=" mt-40 w-full grid place-items-center graph-title  font-libre font-semibold text-lg text-02">
            No active project
          </p>
        ))
      )}
    </div>
  )
}
